import React, { createContext, useContext, useEffect, useState } from 'react';
import UpgradeSubscriptionModal from './UpgradeSubscriptionModal';

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = () => {};

const SidebarNavContext = createContext<{
  close: () => void;
  open: () => void;
  isOpen: boolean;
  toggle: () => void;
  handleShowUpgradeModal: () => void;
  stuck: boolean;
  setStuck: (stuck: boolean) => void;
}>({
  close: noop,
  open: noop,
  isOpen: false,
  toggle: noop,
  handleShowUpgradeModal: noop,
  stuck: false,
  setStuck: noop,
});

const SidebarNavProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [sideNavOpen, setSideNavOpen] = useState(false);
  const [stuck, setStuck] = useState(false);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);

  const close = () => {
    setSideNavOpen(false);
  };

  const open = () => {
    setSideNavOpen(true);
  };

  const toggle = () => {
    setSideNavOpen(!sideNavOpen);
  };

  const handleShowUpgradeModal = () => {
    setShowUpgradeModal(true);
  };

  const handleCloseUpgradeModal = () => {
    setShowUpgradeModal(false);
  };

  useEffect(() => {
    if (showUpgradeModal) setSideNavOpen(false);
  }, [showUpgradeModal]);

  return (
    <>
      <SidebarNavContext.Provider
        value={{
          close,
          open,
          isOpen: sideNavOpen,
          toggle,
          handleShowUpgradeModal,
          stuck,
          setStuck,
        }}
      >
        {children}
      </SidebarNavContext.Provider>
      {showUpgradeModal && (
        <UpgradeSubscriptionModal onClose={handleCloseUpgradeModal} />
      )}
    </>
  );
};

export default SidebarNavProvider;
export const useSidebarNavContext = () => useContext(SidebarNavContext);
